<template>
  <div class="fileList">
    <!-- file list -->
    <el-table ref="table" :data="fromList" style="width: 100%">
      <!-- 多选 -->
      <el-table-column width="40">
        <template slot-scope="scope">
          <div class="file-item-checkbox">
            <el-checkbox
              v-model="scope.row.checkbox"
              v-show="!scope.row.hasOwnProperty('percentage')"
              @change="checkboxChange(scope.row)"
            ></el-checkbox>
          </div>
        </template>
      </el-table-column>
      <!-- 图像 -->
      <el-table-column width="66">
        <template slot-scope="scope">
          <div class="file-item-img">
            <img
              class="file-item-img-url"
              :src="scope.row.thumbnailStr"
              :alt="scope.row.old_filename"
            />
          </div>
        </template>
      </el-table-column>
      <!-- Name -->
      <el-table-column prop="old_filename" :label="this.$t('name')" sortable>
        <template slot-scope="scope">
          <span
            class="file-item-filename"
            :class="[getIsGcode(scope.row) && 'cursor']"
            @click="openViewInfo(scope.row)"
            :title="scope.row.old_filename"
            >{{ scope.row.old_filename }}</span
          >
        </template>
      </el-table-column>
      <!-- Type -->
      <el-table-column prop="file_extension" :label="this.$t('type')" sortable>
        <template slot-scope="scope">
          <span>{{
            scope.row.file_extension
              ? `.${scope.row.file_extension}`
              : scope.row.file_extension
          }}</span>
        </template>
      </el-table-column>
      <!-- Size -->
      <el-table-column prop="size" :label="this.$t('size')" sortable>
        <template slot-scope="scope">
          <span>{{ scope.row.sizeStr }}</span>
        </template>
      </el-table-column>
      <!-- Upload Date -->
      <el-table-column
        prop="create_time"
        :label="this.$t('upload_date')"
        sortable
        min-width="100"
      >
        <template slot-scope="scope">
          <div v-show="scope.row?.percentage != 0">
            <span>{{ scope.row.timeStr }}</span>
          </div>
          <div v-show="scope.row?.percentage == 0" class="progress">
            <el-progress
              :percentage="scope.row.percent || 0"
              :show-text="false"
            ></el-progress>
            <span class="progress-text">{{
              `${$t("uploading")}（${scope.row.percent || 0}%）`
            }}</span>
          </div>
        </template>
      </el-table-column>
      <!-- Edit -->
      <el-table-column>
        <template slot-scope="scope">
          <!-- 默认状态 -->
          <div
            class="file-state"
            v-show="!scope.row.hasOwnProperty('percentage')"
          >
            <div
              v-for="(item, index) in option.fileState"
              :key="index"
              v-show="getHidden(item.label, scope.row)"
              :class="`${item.value}_icon`"
              @click="handlerClick(item.value, scope.row)"
            >
              <img
                :src="require(`@/assets/imgs/cloudSpace/${item.icon}.webp`)"
                alt=""
              />
            </div>
            <fileEditDropdown
              :item="scope.row"
              @fileChange="fileChange"
              type="list"
              @openViewInfo="openViewInfo"
              @pushUserMd5="pushUserMd5"
              @cancelDownload="cancelDownload"
            />
          </div>
          <!-- 上传状态 -->
          <div v-show="scope.row.percentage == 0" class="upload-icon">
            <!-- 上传中 -->
            <div
              class="uploading"
              v-if="scope.row.status !== 'fail'"
              @click="handlerDel(scope.row)"
            ></div>
            <!-- 上传失败 -->
            <div
              class="uploadError"
              v-else
              @click="handleReload(scope.row)"
            ></div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import fileEditDropdown from "./fileEditDropdown";
import { mapState } from "vuex";
import axios from "axios";
export default {
  name: "fileList",
  components: { fileEditDropdown },
  props: {
    fromList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      option: {
        fileState: [
          {
            label: "default",
            value: "default",
            icon: "download-click",
            isClick: true,
          },
          {
            label: "download",
            value: "download",
            icon: "loading_32x32",
            isClick: false,
          },
          {
            label: "import",
            value: "import-success",
            icon: "notification_slicing_complete",
            isClick: false,
          },
          {
            label: "import",
            value: "import",
            icon: "Import-list",
            isClick: true,
          },
        ],
      },
    };
  },
  created() {
    // mac下展示隐藏掉导入按钮
    // const type = this.$common.getSliceType();
    // if (type !== "win") {
    //   this.option.fileState.splice(3, 1);
    // }
  },
  activated() {
    this.$refs.table.doLayout();
  },
  mounted() {},
  computed: {
    ...mapState({
      downloadFileList: (state) => state.user.downloadFileList,
    }),
    getHidden() {
      return (str, obj) => {
        let faild = str == obj.fileStateStr;
        const type = obj.file_extension?.toLowerCase();
        const arr = ["3mf", "gcode", "stl", "step", "svg", "obj", "amf"];
        if (str == "import") {
          faild = faild ? arr.includes(type) || obj.file_type == 2 : false;
        }
        return faild;
      };
    },
    //  判断是否gcode
    getIsGcode() {
      return (obj) => {
        const type = obj.file_extension?.toLowerCase();
        return type == "gcode";
      };
    },
  },
  methods: {
    handlerClick(str, obj) {
      if (str == "import") {
        this.$emit("importModel", obj);
      } else if (str == "default") {
        this.$emit("fileDownload", [obj]);
      }
    },
    pushUserMd5(str, newKey, oldKey, value) {
      this.$emit("pushUserMd5", str, newKey, oldKey, value);
    },
    openViewInfo(obj) {
      if (!this.getIsGcode(obj)) return;
      this.$emit("openViewInfo", obj);
    },
    formatter(row, column) {
      return row.address;
    },
    checkboxChange(obj) {
      this.$emit("fileChange", "update", obj);
    },
    fileChange(str, obj) {
      this.$emit("fileChange", str, obj);
    },
    handlerDel(obj) {
      this.$emit("handleDel", obj);
    },
    handleReload(obj) {
      this.$emit("handleReload", obj);
    },
    cancelDownload(id) {
      this.$emit("cancelDownload", id);
    },
  },
};
</script>
<style scoped lang="scss">
.fileList {
  min-height: 720px;

  .file-item-img {
    display: flex;
    justify-content: center;

    &-url {
      width: 40px;
      height: 40px;
      object-fit: cover;
    }
  }

  .file-item-filename {
    color: var(--VI-color);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .upload-icon {
    display: flex;

    .uploading {
      background: url("@/assets/imgs/cloudSpace/cancel.webp");
      width: 32px;
      height: 32px;
      cursor: pointer;
    }

    .uploading:hover {
      background: url("@/assets/imgs/cloudSpace/cancel_hover.webp");
    }

    .uploadError {
      background: url("@/assets/imgs/cloudSpace/rotate-cw.webp");
      width: 32px;
      height: 32px;
      cursor: pointer;
    }
  }

  .file-state {
    display: flex;
    height: 32px;

    .default_icon {
      cursor: pointer;
    }

    .import_icon {
      cursor: pointer;
    }

    .download_icon {
      animation: 1s rotate linear infinite;
    }
  }

  .progress {
    display: flex;
    align-items: center;

    &-text {
      margin-left: 8px;
      font-size: 13px;
      color: #3986ff;
      line-height: 15px;
    }
  }
}

::v-deep {
  .el-table__body-wrapper {
    overflow: visible;
  }

  .el-table {
    background: var(--print-setting-background-color);
    overflow: visible;
  }

  .el-table th.el-table__cell {
    background: var(--print-setting-background-color);
    height: 40px;
    color: var(--first-text-color);
  }

  .el-table .el-table__cell {
    color: var(--first-text-color);
  }

  .el-table--enable-row-transition .el-table__body td.el-table__cell {
    background: var(--dialog-background-color);
    height: 66px;
    font-size: 14px;
    line-height: 22px;
    color: var(--first-text-color);
  }

  .el-table td.el-table__cell,
  .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid var(--three-btn-border);
  }

  .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background: none;
  }

  .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
    background: var(--dialog-background-color);
  }

  .el-progress--without-text {
    width: 59%;
  }

  .el-table tr {
    background: var(--dialog-background-color);
  }
}

.cursor {
  cursor: pointer;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
  }
}
</style>
